module.exports = __webpack_public_path__ + "img/creds-coffee-cup.54b1ad24.svg";